function NDA_URL_Key(env,id){
    if(env ==='dev'){return `http://localhost:3001/nda?id=${id}`}
    else if(env ==='dep'){return `https://ndaer.netlify.app/nda?id=${id}`}
    else {return `https://ndaer.netlify.app/nda?id=${id}`}
}

export default NDA_URL_Key